import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

import './index.scss';

const Layout = ({ children, data }) => (
  <Fragment>
    <Helmet
      title={data.site.siteMetadata.title}
      meta={[
        { name: 'viewport', content: 'width=device-width, initial-scale=1, shrink-to-fit=no' },
      ]}
      script={[
        // 'https://cdn.polyfill.io/v2/polyfill.min.js',
        { src: '/object-assign.js' },
      ]}
    />
    { children() }
  </Fragment>
);

Layout.propTypes = {
  children: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
};

export default Layout;

export const query = graphql`
  query SiteTitleQuery {
    site {
      siteMetadata {
        title
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/layouts/index.js